export default "__VITE_ASSET__orF1JrFz__"